// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__BmHvN","logoContainer":"Header_logoContainer__Rni0M","pageLabel":"Header_pageLabel__GFd1A","withCursor":"Header_withCursor__V+gQx"};